module.exports = __webpack_public_path__ + "Flag-876.7bd8895af44b3d2234cb2cc3f125d44b.svg";